<div class="expanded-panel-header blue" (click)="toggleExpand()">Property Information</div>
@if(expanded){
  @for(row of rows; track $index){
    <div class="row" style="padding-left: 8px;padding-right: 8px;">
      @for(field of row; track field.key){
        <div class="col-md-6">
          <div class="row align-top" style="border-bottom: 1px solid lightgray">
            <div class="col-md-6 label">{{ field.label }}</div>
            @switch(field.key){
              @case ('is_dda'){
                <div class="col-md-6">{{ detail[field.key] == '0' ? 'No' : 'Yes' }}</div>
              }
              @case ('is_qct'){
                <div class="col-md-6">{{ detail[field.key] == '0' ? 'No' : 'Yes' }}</div>
              }
              @case ('minority_pop_percent'){
                <div class="col-md-6">{{ detail[field.key] | percent: '1.2-2'}}</div>
              }
              @default {
                <div class="col-md-6">{{ detail[field.key] ?? '--' }}</div>
              }
            }
          </div>
        </div>
      }
    </div>
  }
}
